module.exports = __webpack_public_path__ + "static/media/assistlist_background_circle.56d28d74.png";